'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotHistogramIcon = function PlotHistogramIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 24 16' }, props),
        _react2.default.createElement('path', { d: 'M0 11.015h4.003V16H0zm5-6h4.003V16H5zM10 0h4.011v16H10zm5 5.014h4.004V16H15zm4.996 6.001H24V16h-4.004z' })
    );
};

exports.default = PlotHistogramIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotHistogramIcon.js
// module id = 664
// module chunks = 0